export const INSTRUMENT_INFO_ALREADY_COMPLETED =
  'You have already completed this survey. Thank you for your participation.'

/** TC-BE-07 — Start blocked when all slots reserved. */
export const INSTRUMENT_INFO_CAPACITY_REACHED =
  'This survey has reached its response target. Please check back for new surveys!'

/** TC-BE-03 — capacity modal (notification / unavailable access). */
export const INSTRUMENT_INFO_CAPACITY_MODAL =
  'This survey has reached its response target.'

/** TC-BE-11 / BR-BE-07 — session timeout toast (Next / poll). */
export const SURVEY_SESSION_TIMED_OUT = 'Survey session timed out'

/** TC-BE-24 / TC-BE-28 — late submit or sync after timeout. */
export const SURVEY_SESSION_TIMED_OUT_SUBMIT = 'Survey session timed out.'

/** TC-BE-11 — toast visible window and redirect delay (seconds → ms). */
export const SESSION_TIMEOUT_REDIRECT_MS = 3000

export const SURVEY_TARGET_REACHED_IN_SESSION =
  'This survey has reached its response target. Thank you for your participation!'

/** TC-SPW-51 — capacity hit while SP is mid-attempt (submit). */
export const SURVEY_CAPACITY_MID_ATTEMPT =
  'This survey has now reached its maximum responses. Your current progress cannot be submitted.'

export const INSTRUMENT_INFO_PAUSED = 'This instrument is temporarily unavailable'

/** BFP-616 — mid-survey pause/stop unavailable copy. */
export const INSTRUMENT_UNAVAILABLE =
  'Sorry, this instrument is no longer available.'

export const INSTRUMENT_INFO_CLOSED = 'This survey is no longer available.'

export const INSTRUMENT_INFO_START_NETWORK_ERROR =
  'Something went wrong. Please try again.'

export const RESUME_SURVEY_TITLE = 'You have an incomplete survey.'
export const RESUME_SURVEY_BODY = 'Resume where you left off?'

export function earnRewardMessage(display: string): string {
  return `Earn ${display} for completing this survey`
}

/** Figma 5076-7164 — inline reward pill beside Start Survey. */
export function completeSurveyEarnMessagePrefix(): string {
  return 'Complete this survey to earn '
}
